const workStatusData = [
    { id: "1", name: "Employed Full-Time" },
    { id: "2", name: "Employed Part-Time" },
    { id: "3", name: "Self-Employed" },
    { id: "5", name: "Freelancer/Contractor" },
    { id: "6", name: "Intern" },
    { id: "7", name: "Student" },
    { id: "8", name: "Volunteer" },
    { id: "9", name: "Unemployed" },
    { id: "10", name: "Looking for Work" },
    { id: "11", name: "Not Seeking Employment" },
    { id: "12", name: "Retired" }
  ];

export default workStatusData;
  